import React, { useState, useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import makeAnimated from "react-select/animated";
import { 
  Link, 
  useHistory, 
  useParams, 
  useLocation,
} from "react-router-dom";

import { 
  Radio, 
  RadioGroup, 
  TextField, 
  FormControl, 
  FormControlLabel,
  MuiThemeProvider,
  Box,
  LinearProgress,
} from "@material-ui/core";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import {Bars} from  'react-loader-spinner'
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import {createMuiTheme} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import InfoIcon from "@material-ui/icons/Info";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress"
import Backdrop from "@material-ui/core/Backdrop";

import MUIDataTable, { MUISortOptions, SelectableRows } from "mui-datatables";

import { apollo_useStyles } from "../../../atom/Apollo_styles";
import { 
  poseidon_segment_path, 
  segmentlistposeidon_path,
  customsegmentposeidon_path,
  apollo_user_path,
  get_poseidon_condition_path,
} from "../../../atom/Apollo_links";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { ApolloRightDrawerContext } from "../../../molecule/Apollo_RightDrawer";
import GenericTemplate from "../../../templates/GenericTemplate";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";

import {
  Usage, 
  InputType, 
  UsePreference, 
  Operation, 
  AccountCoordinates, 
  EditJSON, 
  initAccountCoordinates,
  initResGetSegment,
  ResGetSegment,
  GetSegmentCondition,
  POSEIDON_CONDITION,
  POSEIDON_CONDITION_UPDATEDAT,
  CustomSegment,
  Status,
} from "./SegmentModel";
import { InformationDrawer } from "../../../organism/SEGMENT/InformationDrawer";

import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";
import { Internal1 } from "../../../organism/SEGMENT/SegmentCondition";

import { cloneDeep, toString } from "lodash";
import {checkInvalidCharForName} from "../../../common/Apollo_CommonUtil";
import {ErrorMessage} from "@hookform/error-message";
import {APOLLO_PAGE_ID, createApolloPageSizeTableOptions} from "../../../common/Apollo_LocalStorageSettings";

type LogRecord = {
  data: CustomSegment,
}

const animatedComponents = makeAnimated();

function getEstimateModalStyle() {
  return {
      top: `80%`,
      left: `50%`,
      width: `450px`,
      transform: `translate(-50%, -50%)`,
      borderRadius: `10px`,
      background: `#1E434C`,
      lineHeight: `20px`,
  };
};

function getCoordinateModalStyle() {
  return {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  };
};

// @ts-ignore
const ModalCoordinate: React.FC<{ 
  setAccountCoordinates: any, 
  accountCoordinates: AccountCoordinates,
  setIsSelectCoordinate: any, 
  setCoordinateOpen: any, 
  editCoordinate: any,
  state: any }> = 
  ({ 
    setAccountCoordinates, 
    accountCoordinates,
    setIsSelectCoordinate, 
    setCoordinateOpen, 
    editCoordinate,
    state 
  }) => 
{
  const classes = apollo_useStyles();
  const theme = createMuiTheme({});

  const columns = [
    { name: "accountGroup", label: "アカウントグループ", options: {filter: true, sort: true,}, },
    { name: "accountId", label: "アカウントID", options: {filter: true, sort: true,}, },
    { name: "account", label: "アカウント名", options: {filter: true, sort: true,}, },
  ];

  type Accounts = {
    accountGroup: string;
    accountId: number;
    account: string;
  };
  
  const [selectRows, setSelectRows] = useState<number[]>([]);
  const [accounts, setAccounts] = useState<Accounts[]>([]);

  let accounts1: Array<Accounts> = [];

  let initCoordinate: AccountCoordinates = {
    id: [],
    name: "",
  };

  const { data, setmsg } = React.useContext(ApolloMessage);

  const [selectCoordinate, setSelectCoordinate] = useState<AccountCoordinates>(initCoordinate);

  const [confirmMsg, setConfirmMsg] = React.useState<string[]>([]);
  const [isSelectRow, setIsSelectRow] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    let coordinates: any = selectCoordinate;
    if (selectCoordinate.id.length === 0) {
      coordinates = accountCoordinates;
    }

    let confirmMsg1: string[] = [];
    let coordinateNames = coordinates.name.split(", ");

    // 確認メッセージ作成
    confirmMsg1.push("以下アカウントを連携しますがよろしいですか？");
    for (let i=0; i<coordinates.id.length; i++) {
      confirmMsg1.push("アカウント名："+coordinateNames[i]+" (ID："+coordinates.id[i]+")");
    }

    setConfirmMsg(confirmMsg1);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    setIsSelectCoordinate(true);

    for(let apolloList of state.apolloList) {
      if (state.current.accountGroupId !== apolloList.accountGroup.id) {
        continue;
      }

      let selectRow1: Array<number> = [];

      let index: number = 0;
      for(let accountList of apolloList.accountList) {
        // 編集時
        for(let vl of accountCoordinates.id) {
          if (accountList.id === vl) {
            selectRow1.push(index)
            break;
          }
        }

        var account: Accounts = {
          accountGroup: state.current.accountGroupName,
          accountId: accountList.id,
          account: accountList.name,
        };
        accounts1.push(account);

        index++;
      }

      setSelectRows(selectRow1);
    }

    setAccounts(accounts1);
  }, []);

  const sortOrder: MUISortOptions = {
    name: "accountId",
    direction: "desc",
  };
  const coordinateTableOptions = createApolloPageSizeTableOptions({
    print: false,
    download: false,
    elevation: 0,
    pagination: true,
    sortOrder: sortOrder,
    selectToolbarPlacement: "above" as "above",
    filterType: "multiselect" as "multiselect",
    rowsSelected: selectRows,
    rowsPerPage: 10,
    onRowSelectionChange: (currentRowSelected: any, allRowSelected: any, rowSelected: any) => {
      setIsSelectRow(true);

      let rows: Array<number> = [];
      let ids: Array<number> = [];
      let accountNames: string = "";

      rowSelected?.map((row: any) => {
        rows.push(row);
        ids.push(accounts[row].accountId);
        accountNames += accounts[row].account + ", ";
      });

      accountNames = accountNames.substring(0, accountNames.length-2);

      let ac1: AccountCoordinates = {
        id: ids,
        name: accountNames,
      };

      setSelectCoordinate(ac1);
      setSelectRows(rows);
    },
    customToolbarSelect: () => undefined,
  }, APOLLO_PAGE_ID.CUSTOM_SEGMENT_ACCOUNT_LINK);

  return (
    <div>
      <Card className={classes.root} square variant="outlined">
        <MuiThemeProvider theme={theme}>
          <MUIDataTable
            title=""
            data={accounts ? accounts : []}
            columns={columns}
            options={coordinateTableOptions}
          />
        </MuiThemeProvider>
        <div style={{marginBottom: "20px"}}>
        <Button 
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={isSelectRow ? false : true}
          onClick={() => {
            if (isSelectRow && selectCoordinate.id.length === 0) {
              const warnMsg: string = "アカウントを1つ以上選択してください。";
              setmsg({
                type: "setMessage",
                payload: {
                  ...data,
                  open: true,
                  type: "warning",
                  message: warnMsg,
                }
              });
              return;
            }

            if (editCoordinate !== undefined && editCoordinate != "") {
              let isCanseledError: boolean = false;
              let canceledAc: string = "";

              editCoordinate.map((id1: any) => {
                let existsAccount: boolean = false;
                for(let apolloList of state.apolloList) {
                  if (state.current.accountGroupId !== apolloList.accountGroup.id) {
                    continue;
                  }
                  for(let accountList of apolloList.accountList) {
                    if (Number(id1) === Number(accountList.id)) {
                      existsAccount = true;
                    }
                  }
                }
                if (!existsAccount) {
                  return true;
                }

                let isCanceled: boolean = true;
                selectCoordinate.id.map((id2: any) => {
                  if (Number(id1) === Number(id2)) {
                    isCanceled = false;
                  }
                });

                if (isCanceled) {
                  isCanseledError = true;

                  for(let apolloList of state.apolloList) {
                    if (state.current.accountGroupId !== apolloList.accountGroup.id) {
                      continue;
                    }
          
                    for(let accountList of apolloList.accountList) {
                      if (Number(accountList.id) === Number(id1)) {
                        canceledAc = accountList.name;
                      }
                    }
                  }
          
                  const warnMsg: string = "連携済のアカウントは解除できません。\r\n(アカウント名："+canceledAc+")";
                  setmsg({
                    type: "setMessage",
                    payload: {
                      ...data,
                      open: true,
                      type: "warning",
                      message: warnMsg,
                    }
                  });
                  return;
                }
              });

              if (isCanseledError) {
                const warnMsg: string = "連携済のアカウントは解除できません。\r\n(アカウント名："+canceledAc+")";
                setmsg({
                  type: "setMessage",
                  payload: {
                    ...data,
                    open: true,
                    type: "warning",
                    message: warnMsg,
                  }
                });
                return;
              }
            }

            setAccountCoordinates(selectCoordinate);
            handleClickOpen();
          }}
        >
          選択
        </Button>
        <Button 
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => {
            setCoordinateOpen(false);
          }}
        >
          戻る
        </Button>
        </div>
      </Card>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>連携アカウント 確認</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {
              confirmMsg ?
              confirmMsg.map((msg: string) =>
                <p>{msg}</p>
              )
              : ""
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              setCoordinateOpen(false);
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};


/*
    画面名：セグメント詳細
 */
const SegmentDetail: React.FC = () => {
  const classes = apollo_useStyles();
  const history = useHistory();
  const formHooks = useForm<FormData>();
  const { errors, control } = formHooks;
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);
  const processing = useRef(false);

  const {segmentId, copySegmentId} = useParams<{
    segmentId: string,
    copySegmentId: string
  }>();

  let query1: URLSearchParams = new URLSearchParams(useLocation().search);
  let breadId: number = (segmentId === "0") ? 2 : (query1.get("type") === "all") ? 3 : 5;

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: breadId,
    queries: [
      segmentId,
      "?type=" + query1.get("type"),
    ],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // フィルター・除外条件 Component
  const [filterComponent1, setFilterComponent1] = useState([1]);
  const [exceptComponent1, setExceptComponent1] = useState([1]);

  function addFilterComponents() {
    setFilterComponent1(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
  };

  function removeFilterComponents(index: number) {
    setFilterComponent1(current => [...current.filter(i => i !== index)]);
  };

  function addExceptComponents() {
    setExceptComponent1(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
  };

  function removeExceptComponents(index: number) {
    setExceptComponent1(current => [...current.filter(i => i !== index)]);
  };

  // 【useState】
  const [modalStyleEstimate] = useState(getEstimateModalStyle);
  const [modalStyleCoordinate] = useState(getCoordinateModalStyle);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext); 

  // 編集時ローディング
  const [bdopen, setbdOpen] = React.useState(false);

  // 情報
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");
  
  // segment
  const [editId, setEditId] = useState("0");
  const [segments, setSegments] = useState<ResGetSegment>(initResGetSegment);
  const [isEdit, setIsEdit] = useState(false);
  const [checkedDocomoLines, setCheckedDocomoLines] = useState(true);
  const [editFilterAndOr, setEditFilterAndOr] = useState("AND");
  const [editExceptAndOr, setEditExceptAndOr] = useState("AND");
  const [editUsage, setEditUsage] = useState<Usage>(Usage.Temporary);
  const [editInputType, setEditInputType] = useState<InputType>(InputType.Condition);
  const [checkUsePreference1, setCheckUsePreference1] = useState(true);
  const [checkUsePreference2, setCheckUsePreference2] = useState(false);
  
  // file
  const [fileInfo, setFileInfo] = useState<File>();
  const [fileName, setFileName] = useState("");

  // account coordinate
  const [accountCoordinates, setAccountCoordinates] = useState<AccountCoordinates>(initAccountCoordinates);
  const [coordinateOpen, setCoordinateOpen] = useState(false);
  const [isSelectCoordinate, setIsSelectCoordinate] = useState(false);

  const [conditionJson, setConditionJson] = useState<EditJSON>();
  const [isAcquiredCondition, setIsAcquiredCondition] = useState(false);
  const [returnBreadId, setReturnBreadId] = React.useState(breadId);

  const beforeEditRecord = useRef<LogRecord | null>(null);

  useEffect(() => {
    if (query1.get("type") === "" || query1.get("type") === null) {
      history.push(segmentlistposeidon_path);
    }

    const init = async () => {
      bdhandleToggle();

      // セグメント条件取得
      await getSegmentConditionInfo();

      if (segmentId !== "0" || copySegmentId !== undefined) {
        if (segmentId !== "0") {
          setEditId(segmentId)
        }
        if (copySegmentId !== undefined) {
          setEditId(copySegmentId)
        }

        // セグメント情報取得
        await getSegmentInfo();
      }

      bdhandleClose();
    }
    init();

    // bdhandleClose();
  }, []);

  /** セグメント条件取得 */
  const getSegmentConditionInfo = async () => {

    let lsCondition = localStorage.getItem(POSEIDON_CONDITION);
    let lsConditionUpdatedAt = localStorage.getItem(POSEIDON_CONDITION_UPDATEDAT);

    let updatedAt1: string = "";
    if (lsCondition != null && lsConditionUpdatedAt != null) {
      updatedAt1 = lsConditionUpdatedAt;
    }

    var request: GetSegmentCondition = {
      updatedAt: updatedAt1,
    };

    const url: string = get_poseidon_condition_path;
    await ApolloAxios.post(url, request).then(response => {
      if (response.data.resultCode < 0) {
        return;
      }

      let result1 = response.data.result;
      localStorage.setItem(POSEIDON_CONDITION, "["+result1.condition+"]");
      localStorage.setItem(POSEIDON_CONDITION_UPDATEDAT, result1.updatedAt);

      setIsAcquiredCondition(true);
    }).catch(err => {
      console.log(err);
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: "セグメント条件のファイルが取得できませんでした。",
        }
      });
    });
    if (localStorage.getItem(POSEIDON_CONDITION) !== null) {
      setIsAcquiredCondition(true);
    }
  }

  /** セグメント情報取得 */
  const getSegmentInfo = async () => {

    let apiSegmentId: string = "";
    copySegmentId !== undefined ? apiSegmentId = copySegmentId : apiSegmentId = segmentId;

    bdhandleToggle();

    let result: any

    // セグメント情報取得
    const url1: string = `${poseidon_segment_path}/${apiSegmentId}`;
    await ApolloAxios.get(url1).then(response => {
      let resultCode: number = response.data.resultCode;
      if (resultCode < 0 || resultCode === 2) {
        let type1: string = "error";
        if (resultCode === 2) {
          type1 = "info";
        }

        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: type1,
            message: response.data.message,
          }
        });

        bdhandleClose();
        return;
      }

      result = response.data.result;

      let beforeSegmentData: CustomSegment = {
        id: 0,
        name: result.name,
        description: result.description === undefined ? "" : result.description,
        uu: 0,
        usage: result.usage,
        inputType: result.inputType,
        coordinatedAccount: result.coordinatedAccount === undefined ? [] : result.coordinatedAccount,
        usePreference: result.usePreference.join(","),
        condition: "",
        conditionJson: result.conditionJson,
        fileName: result.fileName === undefined ? "" : result.fileName,
        createdAt: "",
        createdBy: 0,
        updatedAt: "",
        updatedBy: 0,
        accountGroupId: 0,
      }

      beforeEditRecord.current = {
        data: cloneDeep(beforeSegmentData),
      }

      let copyUsage = result.usage;
      if (copySegmentId !== undefined) {
        copyUsage = Usage.Temporary;
      }

      let result2: ResGetSegment = {
        name: result.name,
        description: result.description,
        status: result.status,
        usage: copyUsage,
        inputType: result.inputType,
        coordinatedAccount: result.coordinatedAccount === undefined ? "" : result.coordinatedAccount,
        usePreference: result.usePreference,
        uu: result.uu,
        fileName: result.fileName,
        conditionJson: result.conditionJson,
        createdAt: result.createdAt,
        createdBy: result.createdBy,
        updatedAt: result.updatedAt,
        updatedBy: result.updatedBy,
        uploadedAt: result.uploadedAt,
        version: result.version,
      };
      
      setSegments(result2);
      setEditUsage(copyUsage);

      // 連携アカウント
      if (result.usage === Usage.Production) {
        let coordinateIds: Array<number> = result.coordinatedAccount;
        let accountNames: string = "";
        let ids: Array<number> = [];

        if (coordinateIds !== null && coordinateIds !== undefined && copySegmentId === undefined) {
          coordinateIds.map((accountId: number) => {
            for(let apolloList of state.apolloList) {
              if (apolloList.accountList === null) {
                continue;
              }
  
              for(let accountList of apolloList.accountList) {
                if (accountList.id === accountId) {
                  ids.push(accountId);
                  accountNames += accountList.name + ", ";
                  break;
                }
              };
            };
          });
  
          accountNames = accountNames.substring(0, accountNames.length-2);
  
          let accounts: AccountCoordinates = {
            id: ids,
            name: accountNames,
          };
  
          setAccountCoordinates(accounts);
          setIsSelectCoordinate(true);
        }
      }

      // セグメントタイプ
      setEditInputType(result.inputType);

      // 利用設定
      setCheckUsePreference1(false);
      setCheckUsePreference2(false);

      if (result.usePreference !== undefined) {
        let usePreferences: any = result.usePreference;

        if (usePreferences.length > 0) {
          usePreferences.map((usePreference: any) => {
            if (usePreference === UsePreference.Target) {
              setCheckUsePreference1(true);
            }
            if (usePreference === UsePreference.Except) {
              setCheckUsePreference2(true);
            }
          });
        }
      }

      if (result.inputType === InputType.Condition) {
        const obj = JSON.parse(result.conditionJson);

        setConditionJson(obj);
        setCheckedDocomoLines(obj.spMode);
        setEditFilterAndOr("")
        setEditFilterAndOr(obj.filter.groupOperation);
        setEditExceptAndOr("")
        setEditExceptAndOr(obj.except.groupOperation);

        // フィルター条件
        removeFilterComponents(1);

        let filterGroupConditions = obj.filter.groupConditions;
        if (filterGroupConditions.length > 0) {
          for (let i = 0; i < filterGroupConditions.length; i++) {
            addFilterComponents();
          };
        }

        // 除外条件
        removeExceptComponents(1);
        
        let exceptGroupConditions = obj.except.groupConditions;
        if (exceptGroupConditions.length > 0) {
          for (let i = 0; i < exceptGroupConditions.length; i++) {
            addExceptComponents();
          };
        }
      }

      if (result.inputType === InputType.File && copySegmentId === undefined) {
        if (result.fileName === undefined) {
          const warnMsg: string = "ファイルがアップロードされていません。再度ファイルをアップロードしてください。";
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "warning",
              message: warnMsg,
            }
          });
        } else {
          setFileName(result.fileName);
        }
      }

      setIsEdit(true);

      const fetch = async () => {
        // 作成者
        const url2: string = `${apollo_user_path}${result.createdBy}`;
        await ApolloAxios.get(url2).then(response => {
          let result1 = response.data.result;

          let createdBy1: string = "undefined (ID：" + result.createdBy + ")";
          if (result1.familyName !== undefined) {
            createdBy1 = result1.familyName + " " + result1.firstName;
          }

          setCreatedBy(createdBy1)
        }).catch(err => {
          console.log(err);
        });

        // 更新者
        const url3: string = `${apollo_user_path}${result.updatedBy}`;
        await ApolloAxios.get(url3).then(response => {
          let result1 = response.data.result;

          let updatedBy1: string = "undefined (ID：" + result.updatedBy + ")";
          if (result1.familyName !== undefined) {
            updatedBy1 = result1.familyName + " " + result1.firstName;
          }

          setUpdatedBy(updatedBy1)
        }).catch(err => {
          console.log(err);
        });
      }
      const fetchAll = async () => {
        await Promise.all(
          [fetch()]
        ).finally(() => {
          console.log("終了");
        })
      }
      fetchAll();

    }).catch(err => {
      const errMsg: string = "セグメント情報の取得に失敗しました。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      bdhandleClose();
    });
  }

  // 編集時ローディング
  const bdhandleToggle = () => {
    setbdOpen(!bdopen);
  };

  const bdhandleClose = () => {
      setbdOpen(false);
  };

  // アカウント連携
  const handleOpenModal = () => {
    setCoordinateOpen(true);
  };

  const handleClose = () => {
    setCoordinateOpen(false);
  };


  // 情報(Drawer)
  function openInformation() {
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    });
  };

  function closeInformation() {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  };

  // 戻る
  const handelGoback = () => {
    history.push(segmentId === "0" ? segmentlistposeidon_path : returnBreadId === 3 ? segmentlistposeidon_path : customsegmentposeidon_path);
  };

  // ファイル選択 変更時
  const fileChange = (e: any) => {
    if (e.target.files !== null) {
      if (e.target.files.length === 0) {
        return;
      }

      setFileInfo(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }

    e.target.value = "";
  }


  return (
    <GenericTemplate title="">
      <CustomizedSnackbars />
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>

      <Backdrop className={classes.backdrop} open={bdopen}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form noValidate>

        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              {segmentId !== "0" ?
                <Grid 
                  container 
                  justify="flex-end"
                  direction="row"
                  spacing={1}
                >
                  <Grid 
                    item xs={3}
                    alignItems="flex-end"
                    style={{paddingLeft: "130px", paddingTop: "25px"}}
                  >
                    <Tooltip 
                      title="情報" 
                      placement="top" 
                      style={{marginLeft: "10px"}}
                    >
                      <Button 
                        variant="contained"
                        onClick={openInformation}
                      >
                        <InfoIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                </Grid>
              : ""}

              {/* 情報表示 (Drawer) */}
              {drawerState.open ? 
                <InformationDrawer
                  obj={segments}
                  closeInformation={closeInformation}
                  typeTitle="セグメントタイプ"
                  createdBy={createdBy}
                  updatedBy={updatedBy}
                />
              : ""}

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  セグメント名 ※
                </Typography>
                <Controller
                  name="segmentName"
                  control={control}
                  components={animatedComponents}
                  key={isEdit ? "Loading" : "Loaded"}
                  defaultValue={copySegmentId !== undefined ? segments.name+"(コピー)" : segments.name}
                  as={
                    <TextField
                      placeholder="※ 必須入力項目"
                      id="segmentName"
                      fullWidth
                    />
                  }
                  rules={{
                    validate: (e: string) => {
                      const errorMessage = checkInvalidCharForName(e)
                      if(errorMessage) {
                        return errorMessage
                      }},
                  }}
                />
                <ErrorMessage
                    errors={errors}
                    name="segmentName"
                    as={<Typography variant="caption" className={classes.errorMessage}/>}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  説明
                </Typography>
                <Controller
                  name="description"
                  control={control}
                  key={isEdit ? "Loading" : "Loaded"}
                  defaultValue={segments.description}
                  as={
                    <TextField
                      id="description"
                      fullWidth
                    />
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  用途設定
                </Typography>
                <div 
                  style={{display: "flex"}}
                >
                  <Controller
                    name="usage"
                    control={control}
                    key={editUsage !== Usage.Temporary ? "Loading" : "Loaded"}
                    defaultValue={editUsage}
                    as={
                      <RadioGroup 
                        row 
                        aria-label="position" 
                        name="position1"
                      >
                        <FormControlLabel
                          value={Usage.Temporary}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editUsage === Usage.Temporary ? true : false}
                              onClick={() => {
                                setEditUsage(Usage.Temporary)
                              }}
                              disabled={segmentId === "0" || segments.usage === Usage.Production ? true : false}
                            />
                          }
                          label="見積用"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={Usage.Production}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editUsage === Usage.Production ? true : false}
                              onClick={() => {
                                setEditUsage(Usage.Production)
                              }}
                              disabled={(
                                segmentId === "0" || copySegmentId !== undefined ||
                                (segmentId !== "0" && segments.status !== Status.Available)) ? true : false
                              }
                            />
                          }
                          label="本番用"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    }
                  />
                </div>
              </Grid>

              {editUsage === Usage.Production ? 
                <Grid item xs={12} >
                  <div style={{display: "flex"}}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={handleOpenModal}
                      style={{marginLeft: 120, marginTop: 0}}
                    >
                      連携アカウント選択
                    </Button>
                    {isSelectCoordinate ? 
                      <p style={{marginLeft: "10px", fontSize: "12px"}}>
                        {accountCoordinates.name}
                      </p> 
                    : ""}
                  </div>
                </Grid>
              : ""}

              {/* 連携先アカウントポップアップ */}
              <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={coordinateOpen}
                onClose={handleClose}>
                <>
                <div 
                  style={modalStyleCoordinate} 
                  className={classes.paper}>
                  <ModalCoordinate
                    setAccountCoordinates={setAccountCoordinates}
                    accountCoordinates={accountCoordinates}
                    setIsSelectCoordinate={setIsSelectCoordinate}
                    setCoordinateOpen={setCoordinateOpen}
                    editCoordinate={segments.coordinatedAccount}
                    state={state}
                  />
                </div>
                </>
              </Modal>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  セグメントタイプ
                </Typography>
                <div style={{display: "flex"}}>
                  <Controller
                    name="inputType"
                    control={control}
                    key={isEdit ? "Loading" : "Loaded"}
                    defaultValue={editInputType}
                    as={
                      <RadioGroup 
                        row 
                        aria-label="position" 
                        name="position1"
                      >
                        <FormControlLabel
                          value={InputType.Condition}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editInputType === InputType.Condition ? true : false}
                              onClick={() => {
                                setEditInputType(InputType.Condition)
                              }}
                              disabled={segmentId !== "0" ? true : false}
                            />
                          }
                          label="条件指定"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={InputType.File}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editInputType === InputType.File ? true : false}
                              onClick={() => {
                                setEditInputType(InputType.File)
                              }}
                              disabled={segmentId !== "0" ? true : false}
                            />
                          }
                          label="ファイル"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    }
                  />
                </div>
              </Grid>

              {editInputType === InputType.File ? 
                <Grid item xs={12}>
                  <input
                    id="file1"
                    type="file"
                    accept="text/csv"
                    style={{display: "none"}}
                    onChange={fileChange}
                  />
                  <label htmlFor="file1" style={{marginRight: "10px"}}>
                    <Button 
                      classes={{root: classes.button}} 
                      variant="outlined" 
                      component="span"
                      style={{marginLeft: 120, marginTop: 0}}
                    >
                      ファイルを選択
                    </Button>
                  </label>
                  <label>{fileName}</label>
                </Grid>
              : ""}

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  利用設定
                </Typography>
                <FormControl>
                  <Grid container spacing={1}>
                    <Grid 
                      container
                      item
                      direction="row"
                      justify="center"
                      alignItems="center"
                    >
                      <img 
                        src={"/img/poseidon/custom_list.png"} 
                        alt="setting" 
                        height="32" 
                        width="32" 
                        style={{ marginRight: "10px" }}
                      />
                      <Controller
                        name="usePreference1"
                        control={control}
                        defaultValue={checkUsePreference1}
                        key={checkUsePreference1 ? "LoadingUsePreference1" : "LoadedUsePreference1"}
                        as={
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                checked={checkUsePreference1}
                                onChange={e => {
                                  setCheckUsePreference1(e.target.checked);
                                }}
                              />
                            }
                            label={<span style={{fontSize: "18px"}}>カスタムリストに利用</span>}
                          />
                        }
                      />
                      <img 
                        src={"/img/poseidon/except_list.png"} 
                        alt="setting" 
                        height="32" 
                        width="32" 
                        style={{ marginRight: "10px" }}
                      />
                      <Controller
                        name="usePreference2"
                        control={control}
                        defaultValue={checkUsePreference2}
                        key={checkUsePreference2 ? "LoadingUsePreference2" : "LoadedUsePreference2"}
                        as={
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                checked={checkUsePreference2}
                                onChange={e => {
                                  setCheckUsePreference2(e.target.checked);
                                }}
                              />
                            }
                            label={<span style={{fontSize: "18px"}}>除外リストに利用</span>}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
            
          {editInputType === InputType.Condition && isAcquiredCondition ? 
            <CardContent>
              <div style={{
                background: "white", 
                padding: "15px", 
                borderRadius: "10px"
              }}>
                <Grid 
                  container 
                  spacing={1} 
                  justify="space-between" 
                  alignItems="center"
                  direction="row"
                >
                  <Grid item xs={6}>
                    <div style={{display: "flex"}}>
                      <p style={{marginRight: "8px"}}>グループ間結合条件</p>
                      <Controller
                        name="filterAndOr"
                        control={control}
                        key={editFilterAndOr ? "Loading" : "Loaded"}
                        defaultValue={editFilterAndOr}
                        as={
                          <RadioGroup 
                            row 
                            aria-label="position" 
                            name="filter-position1"
                          >
                            <FormControlLabel
                              value={Operation.And}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editFilterAndOr === Operation.And ? true : false}
                                  onClick={() => {
                                    setEditFilterAndOr(Operation.And)
                                  }}
                                />
                              }
                              label={Operation.And}
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value={Operation.Or}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editFilterAndOr === Operation.Or ? true : false}
                                  onClick={() => {
                                    setEditFilterAndOr(Operation.Or)
                                  }}
                                />
                              }
                              label={Operation.Or}
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      name="docomoLines"
                      control={control}
                      defaultValue={checkedDocomoLines}
                      key={checkedDocomoLines ? "Loading" : "Loaded"}
                      as={
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={checkedDocomoLines}
                              onChange={e => {
                                setCheckedDocomoLines(e.target.checked);
                              }}
                            />
                          }
                          label={<span style={{fontSize: "18px"}}>docomo回線契約者のみ</span>}
                        />
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    {
                      filterComponent1 ?
                      filterComponent1.map((cmp1: string | number | null | undefined, index: number) =>
                        <Internal1 
                          key={`filter-${cmp1}`}
                          removeComponents={removeFilterComponents}
                          cmp1={cmp1}
                          control={control}
                          condition={conditionJson?.filter.groupConditions[index]}
                          type="filter"
                          editId={editId}
                          bdopen={bdopen}
                        />
                      )
                      : ""
                    }
                    <Tooltip title="条件グループを追加" placement="top">
                      <Fab color="primary" aria-label="add" size="small" style={{marginLeft: "-10px", marginTop: "-10px"}}>
                        <Link to="#" onClick={addFilterComponents} className={classes.link}>
                          <AddIcon/>
                        </Link>
                      </Fab>
                    </Tooltip>
                  </Grid>
                </Grid>
              </div>

              {/* 除外 */}
              <div style={{
                background: "#FFCCBB", 
                padding: "15px", 
                borderRadius: "10px"
              }}>
                <Grid 
                  container 
                  spacing={1} 
                  justify="space-between" 
                  alignItems="center"
                  direction="row"
                >
                  <Grid item xs={6}>
                    <div style={{display: "flex"}}>
                      <h3 style={{marginTop: "15px", marginRight: "8px"}}>除外条件</h3>
                      <p style={{marginRight: "8px", marginTop: "17px", width: "127px"}}>グループ間結合条件</p>
                      <Controller
                        name="exceptAndOr"
                        control={control}
                        key={editExceptAndOr ? "Loading" : "Loaded"}
                        defaultValue={editExceptAndOr}
                        as={
                          <RadioGroup 
                            row 
                            aria-label="except-position" 
                            name="except-position1"
                          >
                            <FormControlLabel
                              value={Operation.And}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editExceptAndOr === Operation.And ? true : false}
                                  onClick={() => {
                                    setEditExceptAndOr(Operation.And)
                                  }}
                                />
                              }
                              label={Operation.And}
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value={Operation.Or}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editExceptAndOr === Operation.Or ? true : false}
                                  onClick={() => {
                                    setEditExceptAndOr(Operation.Or)
                                  }}
                                />
                              }
                              label={Operation.Or}
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        }
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    {
                      exceptComponent1 ?
                      exceptComponent1.map((cmp1: string | number | null | undefined, index: number) =>
                        <Internal1 
                          key={`except-${cmp1}`}
                          removeComponents={removeExceptComponents}
                          cmp1={cmp1}
                          control={control}
                          condition={conditionJson?.except.groupConditions[index]}
                          type="except"
                          editId={editId}
                          bdopen={bdopen}
                        />
                      )
                      : ""
                    }
                    <Tooltip title="除外条件グループを追加" placement="top">
                      <Fab color="primary" aria-label="add" size="small" style={{marginLeft: "-10px", marginTop: "-10px"}}>
                        <Link to="#" onClick={addExceptComponents} className={classes.link}>
                          <AddIcon/>
                        </Link>
                      </Fab>
                    </Tooltip>
                  </Grid>
                </Grid>
              </div>
            </CardContent>
          : ""}
          
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
              disabled={processing.current}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </form>
    </GenericTemplate>
  );
};


export default SegmentDetail;
